module.exports = __webpack_public_path__ + "static/media/we.95630ebb.jpg";